import React, { useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Helmet } from 'react-helmet-async'

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { ReactComponent as Icon } from '../../assets/images/svg/contact.svg';

// Validation helpers
const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const isValidMobile = (mobile) => /^\+?\d+$/.test(mobile); // must start optional + and digits only

const ContactUs = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    mobile: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);
  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();

    const { name, email, mobile, message } = formValues;

    // 1️⃣ Check if any field is empty
    if (!name || !email || !mobile || !message) {
      enqueueSnackbar("Please fill in all fields", { variant: "warning" });
      return;
    }

    // 2️⃣ Validate email
    if (!isValidEmail(email)) {
      enqueueSnackbar("Please enter a valid email address", { variant: "warning" });
      return;
    }

    // 3️⃣ Validate mobile
    if (!isValidMobile(mobile)) {
      enqueueSnackbar("Mobile number can only contain + and digits", { variant: "warning" });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch("/.netlify/functions/sendEmail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formValues),
      });

      if (res.ok) {
        enqueueSnackbar("Message Sent", { variant: "success" });
        setFormValues({ name: "", email: "", mobile: "", message: "" });
      } else {
        enqueueSnackbar("Failed to send message", { variant: "error" });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Error sending message", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='ContactUs' id='contact'>
      <Helmet>
        <title>Contact Us | NEOVERA SURVEYING CORPORATION</title>
        <meta
          name="description"
          content="Get in touch with NEOVERA SURVEYING CORPORATION for inquiries about mineral ore inspection, cargo surveying, and testing services."
        />
        <link rel="canonical" href="https://neoveracsc.com/#contact" />
      </Helmet>

      <h2 className='headingH2'>
        <Icon className='icon' />
        Contact Us
      </h2>

      <div className='ContactUs__item'>
        <form ref={form} onSubmit={sendEmail}>
          <TextField
            id='outlined'
            placeholder='Name'
            multiline
            maxRows={4}
            name="user_name"
            value={formValues.name}
            onChange={(e) =>
              setFormValues({ ...formValues, name: e.target.value })
            }
          />
          <TextField
            id='outlined'
            placeholder='Email Address'
            multiline
            maxRows={4}
            name="user_email"
            value={formValues.email}
            onChange={(e) =>
              setFormValues({ ...formValues, email: e.target.value })
            }
          />
          <TextField
            id='outlined'
            placeholder='Contact Number'
            multiline
            maxRows={4}
            name="user_mobile"
            value={formValues.mobile}
            onChange={(e) =>
              setFormValues({ ...formValues, mobile: e.target.value })
            }
          />
          <TextField
            id='outlined'
            multiline
            rows={4}
            placeholder='Write your Message'
            name="message"
            value={formValues.message}
            onChange={(e) =>
              setFormValues({ ...formValues, message: e.target.value })
            }
          />
          <Button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
